<twc-brand-bar>
    <twc-brand-bar-services-menu> </twc-brand-bar-services-menu>
    <twc-brand-bar-dealer-search></twc-brand-bar-dealer-search>
    <a [routerLink]="['/']" twcBrandBarLogo="topcon"></a>
    <twc-brand-bar-user-menu></twc-brand-bar-user-menu>
</twc-brand-bar>